import gql from 'graphql-tag';








const updateTeamContractsMutation = gql`
  mutation updateTeamContracts(
    $organisationId: String!, 
    $inputs: [TeamContractInput]!, 
    $ghosteeUserEmail: String) 
  {
    updateTeamContracts(
      organisationId: $organisationId,
      inputs: $inputs,
      ghosteeUserEmail: $ghosteeUserEmail
    ) {
      ContractId
  }
}`;

export default (() => ({
  mutation: updateTeamContractsMutation,
  module: 'organisations',
  buildVariables: ({
    organisationId,
    inputs,
    ghosteeUserEmail




  }) => ({
    organisationId,
    inputs,
    ghosteeUserEmail
  })
}));